import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Card, ScreenReaderContainer } from 'components';
import { Heading, Text } from 'components/chroma';

const CardContainer = styled.div`
  margin-left: 1rem;
`;

const OptionalExtraImage = styled.img`
  height: 2.5rem;
  width: 3.5rem;
`;

export const OptionalExtraCard: FunctionComponent<{
  image: string;
  label: string;
  additionalText: string;
  selected: boolean;
  onClick: () => void;
  screenReaderText: string;
}> = ({
  image,
  label: optionalExtraName,
  additionalText = '',
  selected,
  onClick,
  screenReaderText,
}) => (
  <Card
    id={optionalExtraName}
    selected={selected}
    center
    onClick={onClick}
    role="button"
  >
    <OptionalExtraImage
      src={image}
      tabIndex={-1}
      alt={`${optionalExtraName} graphic`}
      aria-hidden
    />
    <CardContainer data-testid={optionalExtraName}>
      <Heading size={5} margin={{ bottom: 0 }}>
        {optionalExtraName}
      </Heading>
      <Text>{additionalText}</Text>
      <ScreenReaderContainer>{screenReaderText}</ScreenReaderContainer>
    </CardContainer>
  </Card>
);
